import { render, staticRenderFns } from "./ColumnWithDataLabels.vue?vue&type=template&id=40137c8e&"
import script from "./ColumnWithDataLabels.vue?vue&type=script&lang=js&"
export * from "./ColumnWithDataLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports